<template>
  <div>
    <el-button :disabled="disabled" type="primary" style="margin-bottom: 8px" @click="$refs.partsEdit.open()"> 添加 </el-button>
    <div class="treeBox">
      <div class="tree">
        <el-tree
          ref="tree"
          :data="treeData"
          default-expand-all
          :props="defaultProps"
          :expand-on-click-node="false"
          node-key="key"
          highlight-current
          @current-change="clickNode"
        ></el-tree>
      </div>
      <div class="table">
        <Table border stripe :columns="columns" :data="currentTableData" :draggable="!disabled" @on-drag-drop="dragHandle">
          <template slot="action" slot-scope="scope">
            <el-button type="danger" :disabled="scope.row.isMainSn || disabled" @click="deletePart(scope.row)">删除</el-button>
          </template>
        </Table>
      </div>
    </div>
    <!-- 部件模态框 -->
    <PartsEdit ref="partsEdit" @save-success="addParts"></PartsEdit>
  </div>
</template>

<script>
import PartsEdit from "./PartsEdit.vue";
export default {
  components: {
    PartsEdit,
  },
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    treeData: {
      handler(val) {
        if (val.length) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(val[0].key);
            this.currentSelectNode = val[0];
            this.currentTableData = this.tableDataCopy.filter((item) => item.processIndex === this.currentSelectNode.processIndex);
          });
        }
      },
    },

    tableData: {
      handler(val) {
        if (val.length) {
          this.tableDataCopy = val;
        }
      },
    },
  },

  data() {
    return {
      defaultProps: {
        label: "title",
      },
      tableDataCopy: [],
      currentSelectNode: {},
      currentTableData: [],
      columns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "部件编号",
          key: "partsNo",
          width: 120,
          align: "center",
        },
        {
          title: "部件名称",
          key: "partsName",
          minWidth: 360,
          tooltip: true,
        },
        {
          title: "主条码",
          key: "isMainSn",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isMainSn ? "是" : "否");
          },
        },
        {
          title: "唯一码",
          key: "isUniqueSn",
          width: 90,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isUniqueSn ? "唯一码" : "自制条码");
          },
        },
        {
          title: "固定工时",
          key: "fixedWorkingTime",
          width: 90,
          align: "center",
        },
        {
          title: "变动工时",
          key: "variableWorkingTime",
          width: 90,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 80,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },

  methods: {
    clickNode(data) {
      if (data.hasOwnProperty("children")) {
        this.currentSelectNode = data;
        this.currentTableData = this.tableDataCopy.filter((item) => item.processIndex === data.processIndex);
      }
    },

    addParts(data) {
      const maxScanIndex = Math.max.apply(
        Math,
        this.currentTableData.map((item) => {
          return item.scanIndex;
        })
      );
      const obj = {
        scanIndex: maxScanIndex + 1,
        partsNo: data.partsNo,
        partsName: data.partsName,
        isMainSn: false,
        isUniqueSn: data.isUniqueSn,
        fixedWorkingTime: data.fixedWorkingTime,
        variableWorkingTime: data.variableWorkingTime,
        processId: this.currentSelectNode.processId,
        processIndex: this.currentSelectNode.processIndex,
        timeUnit: this.currentTableData[0].timeUnit,
        workCenterNo: this.currentTableData[0].workCenterNo,
        seqNumber: this.currentTableData[0].seqNumber,
        proDepartmentNo: this.currentTableData[0].proDepartmentNo,
      };
      this.currentSelectNode.children.push({ title: "扫描序号" });
      this.currentSelectNode.children.forEach((item, index) => {
        item.title = "扫描序号" + (index + 1);
      });
      this.tableDataCopy.push(obj);
      this.currentTableData.push(obj);
      this.$emit("tableUpdate", this.tableDataCopy);
    },

    deletePart(row) {
      this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
        this.currentTableData = this.currentTableData.filter((item) => item.scanIndex !== row.scanIndex);
        this.currentTableData.forEach((item, index) => {
          item.scanIndex = index + 1;
        });
        const newArr = this.tableDataCopy.filter((item) => item.processIndex !== this.currentSelectNode.processIndex);
        this.tableDataCopy = newArr.concat(this.currentTableData);
        this.currentSelectNode.children.pop();
        this.$emit("tableUpdate", this.tableDataCopy);
      });
    },

    dragHandle(index1, index2) {
      const temp = this.currentTableData[index1].scanIndex;
      this.currentTableData[index1].scanIndex = this.currentTableData[index2].scanIndex;
      this.currentTableData[index2].scanIndex = temp;
      this.currentTableData[index1] = this.currentTableData.splice(index2, 1, this.currentTableData[index1])[0];
      const newArr = this.tableDataCopy.filter((item) => item.processIndex !== this.currentSelectNode.processIndex);
      this.tableDataCopy = newArr.concat(this.currentTableData);
      this.$emit("tableUpdate", this.tableDataCopy);
    },
  },
};
</script>

<style lang="scss" scoped>
.treeBox {
  display: flex;
  .tree {
    flex: 1;
    border: 1px solid #ddd;
    margin-right: 5px;
    padding: 5px;
  }
  .table {
    width: 870px;
  }
}
</style>

<style>
.treeBox .el-tree-node__children .el-tree-node__content {
  padding-left: 2px !important;
}
</style>
